export default "__VITE_ASSET__a99e38ac__"